{
  "common" : {
    "show" : "Vis",
    "about" : "Om",
    "newPost" : "Nytt innlegg",
    "active" : "Aktiv",
    "change" : "Endre",
    "remove" : "Fjern",
    "cancel" : "Kanseller",
    "publish" : "Publiser",
    "save" : "Lagre",
    "draft" : "Utkast",
    "scheduled" : "Planlagt",
    "published" : "Publisert",
    "actions" : "Handlinger",
    "archive" : "Arkiver",
    "delete" : "Slett",
    "edit" : "Rediger",
    "edited" : "Redigert",
    "settings" : "Innstillinger",
    "updatedOn" : "Oppdatert den",
    "blogPost" : "Blogginnlegg",
    "category" : "Kategori",
    "author" : "Forfatter",
    "status" : "Status",
    "errors" : "Feil",
    "all" : "Alle",
    "archived" : " Arkivert",
    "back" : "Tilbake",
    "restore" : "Tilbakestill denne versjonen",
    "next" : "Neste",
    "previous" : "Forrige",
    "continue" : "Fortsett",
    "paid" : "Betalt",
    "free" : "Gratis",
    "uploadImagesVideos" : "Last opp bilder/videoer",
    "upload" : "Last opp",
    "add" : "Legg til",
    "to" : "til",
    "on" : "På",
    "from" : "fra",
    "members" : "Medlemmer",
    "visibility" : "Synlighet",
    "private" : "Privat",
    "public" : "Offentlig",
    "description" : "Beskrivelse",
    "managedBy" : "Administrert av",
    "noManagers" : "Ingen behandlere",
    "noDescription" : "Ingen beskrivelse",
    "more" : "mer",
    "less" : "mindre",
    "and" : "og",
    "in" : "i",
    "allSet" : "Du er klar!",
    "createdBy" : "Opprettet av",
    "home" : "Hjem",
    "selected" : "Utvalgt",
    "groupMembers" : "Gruppemedlemmer",
    "everyone" : "Alle",
    "manager" : "Ansvarlig",
    "leave" : "Forlat",
    "membersList" : "Medlemsliste",
    "findChannelManagers" : "Finn kanaladministratorer",
    "searchGroupMembers" : "Søk etter gruppemedlemmer",
    "searchMembers" : "Søk etter medlemmer",
    "searchMember" : "Søk etter medlem",
    "enterDescription" : "Angi beskrivelse",
    "apply" : "Bruk",
    "selectRole" : "Velg rolle",
    "people" : "Mennesker",
    "viewProfile" : "Se profil",
    "leaderboard" : "Ledertavle",
    "events" : "Hendelser",
    "logOut" : "Logg ut",
    "share" : "Del",
    "copyLink" : "Kopier lenke",
    "reply" : "Svar",
    "download" : "Last ned",
    "noPreviewAvailable" : "Ingen forhåndsvisning tilgjengelig",
    "userNotFound" : "Bruker ble ikke funnet",
    "unableToPreviewPdf" : "For øyeblikket kan du ikke forhåndsvise PDF-filen. Last den ned for å se den.",
    "failedToDownloadPdf" : "Kunne ikke laste ned PDF-filen",
    "notifyAll" : "Gi beskjed til alle i kanalen",
    "communities" : "Lokalsamfunn",
    "courses" : "Kurs",
    "affiliates" : "Tilknyttet",
    "chats" : "Chat",
    "switchToDarkMode" : "Bytt til mørk modus",
    "switchToLightMode" : "Bytt til lys modus",
    "editProfile" : "Rediger profil",
    "account" : "Konto",
    "logout" : "Logg ut",
    "noResults" : "Ingen resultater",
    "confirmPayment" : "Bekreft betaling",
    "done" : "Fullført",
    "manage" : "ADMINISTRER",
    "copied" : "Kopiert",
    "submit" : "Send inn",
    "request" : "Forespørsel",
    "approve" : "Godkjenn",
    "decline" : "Avslå",
    "comingSoon" : "Kommer snart",
    "detailsUpdatedSuccessfully" : "Detaljene har blitt oppdatert",
    "oopsUnableToSaveDetails" : "Oops! Kan ikke arkivere detaljer.",
    "verificationFailedPleaseTryAgain" : "Verifisering mislyktes. Prøv igjen",
    "loading" : "Laster",
    "title" : "Tittel",
    "addLink" : "Legg til lenke",
    "writeHere" : "Skriv her",
    "copy" : "Kopier",
    "register" : "Registrer deg",
    "registered" : "Registrert",
    "search" : "Søke",
    "confirm" : "Bekreft",
    "success" : "Vellykket",
    "toReview" : "For å Vurdering",
    "invite" : "Inviter",
    "contributions" : "Bidrag",
    "communitiesSettings" : "Innstillinger for fellesskap",
    "create" : "Opprett",
    "name" : "Navn",
    "linkCopied" : "Lenke Kopiert.",
    "move" : "Flytte",
    "irreversible" : "irreversible",
    "close" : "Lukk",
    "greeting" : "Hei, {name}!",
    "managePayments" : "Administrere betalinger",
    "manageYourAccount" : "Administrere Konto din",
    "accountSettings" : "Konto Innstillinger",
    "proceed" : "Fortsett",
    "uploading" : "Laster opp",
    "retry" : "Prøv på nytt",
    "login" : "Login"
  },
  "imageUpload" : {
    "cropYourAvatar" : "Beskjær avataren din",
    "dragToReposition" : "Dra for å flytte"
  },
  "mediaUpload" : {
    "uploadVideo" : "Last opp video",
    "addVideoUsingLink" : "Legg til video via lenke"
  },
  "mandatedInfoModal" : {
    "completeYourProfile" : "Fullfør profilen din",
    "profileIntentMessage1" : "Fellesskap kan føles rare uten ansikter og navn.",
    "profileIntentMessage2" : "Profiler bygger tillit og skaper forbindelser med andre",
    "complete" : "FULLFØRT",
    "recommendedAspectRatio" : "Last Laste opp en {types}. Anbefalt Utseende Prosentdel 1:1",
    "addBio" : "Legg til en bio... (valgfritt)"
  },
  "validations" : {
    "nameRequired" : "Navn er påkrevd.",
    "invalidDescription" : "Ugyldig beskrivelse."
  },
  "payment" : {
    "recurringWithTrial" : "Du vil bli belastet {currencySymbol}{price} per {interval} etter prøveperioden er over, med muligheten til å kansellere når som helst.",
    "recurring" : "{currencySymbol}{price} per {interval}, med muligheten til å kansellere når som helst.",
    "oneTime" : "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText" : "engangspris for medlemskap.",
    "totalAmount" : "Totalbeløp",
    "trialDays" : "{days} dagers prøveperiode",
    "securePayments" : "100 % sikre og trygge betalinger",
    "allowToChargeCard" : "Ved å oppgi kortinformasjonen din, tillater du {locationName} å belaste kortet for fremtidige betalinger i samsvar med vilkårene deres.",
    "paymentSuccessful" : "Betaling vellykket."
  },
  "channel" : {
    "notifications" : {
      "managersEdited" : "Ansvarlige har blitt redigert.",
      "managersAdded" : "Ansvarlige har blitt lagt til.",
      "managersAddedToChannel" : "ansvarlige lagt til i",
      "memberPostingEnabled" : {
        "title" : "Oppdatert Medlemmer-innlegg vellykket",
        "content" : "Medlemmers innlegg har vært Aktivert"
      },
      "memberPostingDisabled" : {
        "title" : "Oppdatert Medlemmer-innlegg vellykket",
        "content" : "Medlemmers innlegg har blitt deaktivert"
      },
      "created" : {
        "title" : "Ny kanal opprettet",
        "content" : ""
      },
      "updated" : {
        "title" : "Oppdaterte kanalinnstillinger",
        "content" : ""
      },
      "deleted" : {
        "title" : "Kanalen ble slettet",
        "content" : ""
      },
      "error" : {
        "createFailed" : {
          "title" : "Kan ikke opprette kanal",
          "content" : "Prøv igjen senere"
        },
        "updateFailed" : {
          "title" : "Kunne ikke oppdatere kanalen",
          "content" : "Prøv igjen senere"
        },
        "managersEditedFailed" : {
          "title" : "Oppdatering av ansvarlige var mislykket.",
          "content" : ""
        },
        "addFailed" : {
          "title" : "Det var ikke mulig å legge til ledere.",
          "content" : ""
        }
      }
    },
    "createChannel" : "Skape KANAL",
    "updateChannel" : "OPPDATERING AV KANAL",
    "addMembers" : "Legg til medlemmer",
    "addManagers" : "Legg til ansvarlige",
    "typeToAddMoreMembers" : "Skriv inn for å legge til flere medlemmer",
    "examplePlaceholder" : "f.eks. John eller Jane",
    "makeChannelManager" : "Opprett kanaladministrator",
    "removeFromChannelManager" : "Fjern fra kanaladministrator",
    "manager" : "Ansvarlig",
    "channelManager" : "Kanaladministrator",
    "noMembersFound" : "Ingen medlemmer funnet.",
    "noManagersFound" : "Ingen ansvarlige funnet.",
    "removeChannelMember" : "Fjern kanalmedlem",
    "removeConfirmationMessage" : "Er du sikker på at du vil fjerne",
    "makeManagerConfirmationMessage" : "Er du sikker på at du vil gjøre",
    "makeManagerConfirmationMessage2" : "til en kanaladministrator i",
    "channelName" : "Kanalnavn",
    "channelIcon" : "Kanalikon",
    "addChannel" : "Legg til kanal",
    "editChannel" : "Redigere kanal",
    "announcementChannel" : "MERKNAD-kanalen",
    "noChannelsAvailable" : "Ingen kanaler tilgjengelig",
    "makeChannelPrivate" : "Gjør kanalen privat",
    "makeChannelPrivateMessage" : "Begrens medlemmets tilgang til alle kanaldiskusjoner og interaksjoner.",
    "readOnlyChannel" : "Lese kanal",
    "readOnlyChannelMessage" : "Medlemmer kan se VIKTIG informasjon og oppdateringer, men kun administratorer/eiere av kanalen kan slette henne.",
    "createPrivateChannel" : "Skape denne kanalen Privat",
    "createPrivateChannelMessage" : "Kun inviterte Medlemmer . Ikke-medlemmer vil ikke se denne rom-en",
    "allowMembersToPost" : "Aktivere Medlemmer til Dele",
    "allowMembersToPostMessage" : "Aktiverer dette alternativet Aktivere medlemmer til Skape innlegg og tilbakemelding",
    "enableMemberPostingConfirmation" : {
      "mainMessage" : "Å aktivere Medlemmer-innlegg vil Aktivere hver eneste Medlemmer å Skape og slette innlegg i kanalen.",
      "mainMessage2" : "Sikre at hver eneste medlemmer er klar over ny posting Tillatelser.",
      "pointer1" : "Denne håndteringen kan tilbakestilles når som helst.",
      "pointer2" : "hvert eneste innlegg Laget av Medlemmer vil være synlig for Alle in kanalen."
    },
    "restrictMembersFromPosting" : "Begrens Medlemmer Fra-oppslag",
    "restrictMembersFromPostingMessage" : "Deaktiver dette alternativet vil forhindre Medlemmer Fra Opprettet Eller å redigere innlegg og tilbakemelding i kanalen.",
    "disableMemberPostingConfirmation" : {
      "mainMessage" : "Deaktivering av medlemmer vil begrense hvert eneste medlem fra Opprettet og deling av innlegg i kanalen.",
      "mainMessage2" : "Sikre at hver eneste medlem er klar over de nye postingsrestriksjonene.",
      "pointer1" : "Denne håndteringen kan tilbakestilles når som helst.",
      "pointer2" : "hvert eneste innlegg Laget av Medlemmer Før denne Endre vil forbli synlig for Alle in kanalen."
    },
    "deleteChannel" : "Slett kanal",
    "deleteChannelMessage" : "Sletting av kanalen vil føre til at alle tilknyttede data vil gå tapt for godt.",
    "deleteChannelMessageWithCourse" : "Hvis du sletter kanalen, vil du miste hver eneste medlemmer-data permanent, og eventuelle kurs knyttet til denne kanalen vil bli offentlig med mindre du sletter dem først.",
    "editChannelName" : "Rediger kanalnavn",
    "editChannelDescription" : "Rediger kanalbeskrivelse",
    "channelNamePlaceholder" : "f.eks. markedsføringsrapporter",
    "editManagers" : "Rediger ledere",
    "channelManagers" : "Kanaladministratorer",
    "leaveChannel" : "Forlat kanal",
    "leaveChannelConfirmation" : "Er du sikker på at du vil forlate denne kanalen?",
    "changeToPrivateChannel" : "Gjør kanalen privat",
    "changeToPrivateChannelMessage" : "Å gjøre kanalen privat vil begrense bruken av kanalen for interaksjoner og diskusjoner til kun medlemmer.",
    "changeToPrivateChannelConfirmation" : {
      "mainMessage" : "Å bytte denne kanalen til Privat vil kun SLOTMAX Tilgang til Valgt Medlemmer og ledere.",
      "mainMessage2" : "Husk å inkludere hver eneste ønskede Medlemmer til din private kanal.",
      "pointer1" : "Denne håndteringen er",
      "pointer2" : "ny Medlemmer lagt til i kanalen vil ha Tilgang til hver eneste FORTID diskusjoner og interaksjoner i kanalen."
    },
    "peopleWhoCanManage" : "Personer som kan administrere",
    "addChannelHelperText" : "Vis mer fellesskap: Legge til-kanaler for diverse diskusjoner, Duet og tilkobling."
  },
  "chat" : {
    "unblockUser" : "Fjern blokkering av bruker",
    "blockUser" : "Blokker bruker",
    "blockMessage1" : "Du vil ikke lenger kunne laste opp meldinger til denne brukeren.",
    "blockMessage2" : "Denne kontoen vil ikke bli blokkert på gruppen. Det kan hende du fortsatt kan se innleggene, kommentarene og reaksjonene deres.",
    "deleteChat" : "Slett chat",
    "deleteChatMessage" : "Er du sikker på at du vil slette denne samtalen?",
    "block" : "Blokker",
    "conversation" : "samtale",
    "messageNotSent" : "Denne meldingen ble ikke sendt",
    "sending" : "Sender",
    "youAndUserKnowEachOther" : "Du og {name} kjenner hverandre",
    "startConversationWithHi" : "Start en samtale ved å si «Hei»",
    "accountSettings" : "Kontoinnstillinger",
    "blockedUserMessage" : "Du har blokkert { name }. Dere kan ikke sende eller motta meldinger. Opphev blokkeringen for å starte en samtale. For å se gjennom listen din over blokkerte brukere, besøk din",
    "blockRecipientMessage" : "{ name } har blokkert deg. Dere kan ikke sende eller motta meldinger.",
    "nothingFound" : "Ingenting ble funnet.",
    "pleaseCheckUsername" : "Vennligst sjekk brukernavnet og prøv på nytt",
    "startChatting" : "Begynn å chatte",
    "noChatYet" : "Det ser ut til at du ikke har chattet med noen ennå.",
    "noChatYetMessage" : "Søk etter en kontakt og ta det første skrittet!",
    "noConversationsFound" : "Ingen samtaler funnet",
    "searchMembersAndStartChatting" : "Søk etter medlemmer og begynn å chatte",
    "cannotMessageDeletedUser" : "Du kan ikke laste opp meldinger til en Slettet Bruker",
    "message" : "Melding",
    "media" : "Media",
    "files" : "Filer"
  },
  "comments" : {
    "reportComment" : "Rapporter kommentar",
    "reportCommentMessage" : "Er du sikker på at du vil rapportere denne kommentaren?",
    "deleteComment" : "Slett kommentar",
    "editComment" : "Rediger kommentar",
    "loadMoreReplies" : "Last inn flere svar",
    "deleteCommentMessage" : "Er du sikker på at du vil slette denne kommentaren?",
    "writeComment" : "Skriv en kommentar",
    "comment" : "KOMMENTAR",
    "cancel" : "KANSELLER",
    "save" : "LAGRE",
    "replyingTo" : "Svarer til",
    "newComment" : "ny kommentar",
    "latest" : "Siste",
    "onlyAdminsCanComment" : "Kun fellesskapsadministratorer kan kommentere in denne kanalen."
  },
  "embeds" : {
    "uploadImage" : "Last opp bilde",
    "addYoutubeVimeoLoomLink" : "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadAttachment" : "Last opp PDF-, CSV- eller XLSX-filer",
    "addAttachment" : "Legg til vedlegg",
    "allowedTypes" : "SVG-, PNG-, JPG- eller GIF-fil (maks. 800x400px)",
    "placeholder" : "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadVideo" : "Last opp / link til video",
    "uploadVideoPlaceholder" : "Legg til en Youtube-, Vimeo- eller Loom-lenke",
    "uploadVideoAllowedTypes" : "Last opp en MP4-videofil",
    "addEmoji" : "Legg til emoji",
    "emojiSuggestion" : "Åpner emoji-velgeren",
    "addGif" : "Legg til GIF-fil",
    "gifSuggestion" : "Åpner GIF-velger",
    "addImage" : "Legg til bilde",
    "imageSuggestion" : "Åpner galleriet ditt",
    "addVideo" : "Legg til video",
    "videoSuggestion" : "Åpner galleriet ditt",
    "selectFile" : "Velg fil",
    "attachmentSuggestion" : "Åpner filbehandler",
    "takePhoto" : "Ta bilde",
    "uploadPhotoVideo" : "Last opp foto/video",
    "limitExceeded" : "Grensen er nådd",
    "limitExceededMessage" : "Du kan ikke legge ved mer enn fire filer",
    "errorWhileUploadingFile" : "Feil under opplasting av fil. Prøv igjen",
    "clickToUpload" : "Klikk for å laste opp",
    "orDragAndDrop" : "eller dra og slipp",
    "validUrl" : "Gyldig URL er nødvendig",
    "enterSomeText" : "Skriv inn tekst",
    "addLink" : "Legg til lenke",
    "text" : "Tekst",
    "addVideoLink" : "Eller, Inkludere a YouTube, Vimeo, Loom, Eller Wistia Video Lenke.",
    "uploadVideoAndImages" : "Laste opp videoer og bilder",
    "recommendedAspectRatio" : "Anbefalt Utseende Prosentdel {ratio}"
  },
  "tabSwitcher" : {
    "discussion" : "Diskusjon",
    "learning" : "Læring",
    "members" : "Medlemmer",
    "leaderboard" : "Ledertavle",
    "channels" : "Kanaler",
    "groups" : "Grupper",
    "more" : "Mer",
    "home" : "Hjem"
  },
  "groupInfo" : {
    "pinGroup" : "Fest Gruppe",
    "unpinGroup" : "Løsne Gruppe",
    "maxPinnedGroupsLimit" : "Kun opptil 4 grupper kan festes",
    "publicGroup" : "Offentlig gruppe",
    "privateGroup" : "Privat gruppe",
    "members" : "Medlemmer",
    "posts" : "Innlegg",
    "admin" : "Admin",
    "settings" : "INNSTILLINGER",
    "inviteMembers" : "INVITER MEDLEMMER",
    "answerQuestions" : "Svar på spørsmål",
    "toJoin" : "for å bli med i {name}",
    "changeRole" : "Endre rolle",
    "removeFromGroup" : "Fjern fra gruppen",
    "contributor" : "Bidragsyter",
    "membershipAnswers" : "Svar om medlemskap",
    "unbanMember" : "Fjern utestengelse av medlem",
    "banFromGroup" : "Utesteng fra gruppe",
    "requestedOn" : "Forespurt",
    "invitedOn" : "Invitert",
    "joinedOn" : "Ble med",
    "noMembersFound" : "Ingen medlemmer funnet.",
    "youAreAllCaughtUp" : "Du er hver eneste gang – ingen medlemmer her Høyre nå!",
    "banUserConfirmation" : "Er du sikker på at du vil utestenge denne brukeren fra gruppen?",
    "deleteContentCheckbox" : "Slett hver eneste Innhold Laget av denne Bruker",
    "active" : "Aktiv",
    "admins" : "Administratorer",
    "contributors" : "Bidragsytere",
    "requested" : "Forespurt",
    "banned" : "Utestengt",
    "invited" : "Invitert",
    "answeredQuestions" : "Besvarte spørsmål",
    "answeredQuestionsMessage" : "svarte på følgende spørsmål for å bli med",
    "darkMode" : "Mørk modus",
    "darkModeMessage" : "Juster utseendet på fellesskapet for å redusere gjenskinn og gi øynene dine en pause.",
    "accessGranted" : "Tilgang godkjent: Begynn læringseventyret ditt.",
    "paymentReceived" : "Betaling ble mottatt, og din forespørsel om å bli med i gruppen er under vurdering.",
    "stepIntoAction" : "Sett i gang! La oss samarbeide og ha det gøy.",
    "viewMembersAndMemberDetails" : "Se medlemmer og medlemsdetaljer",
    "reviewContentReportsAndMore" : "Gjennomgå innholdsrapporter og mer",
    "toReview" : "Til vurdering",
    "switchToOtherGroups" : "Bytt til Annen/annet Gruppe",
    "placeholders" : {
      "yourAnswer" : "Ditt svar"
    },
    "notifications" : {
      "userBanned" : "Brukeren ble utestengt fra gruppen",
      "somethingWentWrong" : "Noe gikk galt. Prøv igjen senere."
    },
    "membershipSettings" : "Medlemskapsinnstillinger",
    "paymentFailed" : "Betaling mislyktes.",
    "paymentFailedMessage" : "Betaling mislyktes, og forespørselen din om å bli med i gruppen har blitt avvist.",
    "gamification" : {
      "addRewards" : "Legg til belønninger",
      "title" : "Tittel",
      "description" : "Legg til beskrivelse",
      "textbox" : "Tekstboks",
      "singleSelect" : "Enkeltvalg",
      "multipleSelect" : "Flere valg",
      "question" : "Spørsmål",
      "validations" : {
        "titleRequired" : "Vennligst oppgi tittel",
        "descriptionRequired" : "Vennligst gi en beskrivelse",
        "somethingWentWrong" : "Noe gikk galt. Prøv igjen senere.",
        "updatedRewards" : "Oppdaterte belønninger"
      }
    },
    "customCode" : {
      "advanced" : "Avansert",
      "testPreview" : "Test forhåndsvisning",
      "enableConfirmationMessage" : "Aktiver det bare når du har bekreftet testforhåndsvisningen",
      "testPreviewMessage" : "Dette åpner en ny fane med testforhåndsvisningen av fellesskapet ditt. Du kan bruke denne til å sjekke om den egendefinerte koden fungerer som forventet.",
      "liveMode" : "Direkte modus",
      "customJS" : "Tilpasset JS",
      "customCSS" : "Tilpasset CSS",
      "trackingCode" : "Sporingskode",
      "headerCode" : "Kode",
      "footerCode" : "Bunntekst Kode"
    },
    "branding" : {
      "brandYourGroup" : "Du kan profilere gruppen din etter eget valg her",
      "updateBranding" : "Oppdater profilering",
      "clickToUploadFavicon" : "Klikk for å laste opp Favicon",
      "dragAndDropFavicon" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "clickToUploadCover" : "Klikk for å laste opp dekke",
      "dragAndDropCover" : "Drag and drop a {types} (Aspect Ratio 16:9)",
      "clickToUploadLogo" : "Klikk for å laste opp gruppelogo",
      "dragAndDropLogo" : "Drag and drop a {types} (Aspect Ratio 1:1)",
      "aspectRatioMustBe1To1" : "Størrelsesforholdet til bildet må være 1:1",
      "aspectRatioMustBe16To9" : "Størrelsesforholdet til bildet må være 16:9",
      "favicon" : "Favicon",
      "coverImage" : "Forsidebilde",
      "logo" : "Logo",
      "invalidFileFormat" : "Oops! Invalid File Format/Type.",
      "pleaseUploadImageType" : "Supported file types: {types}"
    },
    "groupAppearance" : {
      "description" : "Du kan konfigurere din Gruppe Utseende per ditt valg her",
      "slug" : "Oppdater Gruppe Utseende her",
      "colorMode" : "Farge",
      "previewTheLook" : "Forhåndsvisning hvordan gruppen din vil Utseende in Lyst- og Mørk-modus",
      "light" : "Lyst",
      "dark" : "Mørk",
      "communityTheme" : "fellesskap Tema",
      "customTheme" : "Tilpasset Tema",
      "windowGradient" : "Vindu- Gradient",
      "applyGradientColorsToYourSidebarAndTopbar" : "Iverksette Gradient til sidefeltet og topplinjen",
      "labels" : {
        "sidebarBackground" : "Bakgrunn for sidefelt",
        "primary" : "PRIMÆR",
        "secondary" : "Sekundær",
        "tertiary" : "Tertiær",
        "surface" : "Overflate",
        "fontPrimary" : "PRIMÆR Font",
        "fontSecondary" : "Sekundær skrift",
        "fill" : "Fylle Farge",
        "border" : "Kant",
        "error" : "Feil",
        "background" : "Bakgrunn"
      },
      "customThemes" : {
        "default" : "Standard",
        "zestyCitrus" : "Sjarmerende sitrus",
        "royalVelvet" : "Royal Velvet",
        "sunnyDelight" : "Sunny Delight",
        "lushMeadow" : "Frodig eng",
        "azureDreams" : "Azure drømmer",
        "bubblegumBliss" : "Bubblegum Bliss",
        "ivoryWhisper" : "Ivory Whisper",
        "midnightDeep" : "Midnight Deep"
      },
      "unsavedChanges" : "Ikke-lagret Dynamisk",
      "unsavedChangesMessage" : "Du har ulagret Tema Dynamisk, er du sikker på at du vil Angre the Dynamisk?"
    },
    "promotionalLinks" : {
      "promotionalLinks" : "Kampanjelenker",
      "createPromotionalLinkDescription" : "Opprett kampanjelenker for gruppen din",
      "addPromotionalLink" : "Legg til lenke",
      "deleteLink" : "Slett lenke",
      "deleteLinkConfirmation" : "Er du sikker på at du vil slette denne lenken?",
      "labels" : {
        "description" : "Beskrivelse",
        "url" : "URL",
        "private" : "Privat",
        "privateLinksDescription" : "Private lenker er bare synlige for gruppemedlemmer"
      },
      "placeholders" : {
        "enterLinkDescription" : "Skriv inn lenkebeskrivelse",
        "enterLinkURL" : "Skriv inn lenke-URL"
      },
      "addPromotionalLinkDescription" : "Skape Kampanjelenker for din gruppe"
    },
    "membershipQuestions" : {
      "addQuestion" : "Legg til spørsmål",
      "editQuestion" : "Rediger spørsmål",
      "editLevelName" : "Rediger nivånavn",
      "addOption" : "Legg til alternativ",
      "level" : "Nivå",
      "name" : "Navn",
      "addMembersQuestionsDescription" : "Legg til spørsmål for medlemmer som kan stilles når de ber om tilgang til gruppen din",
      "enableMembershipQuestions" : "Aktiver spørsmål om medlemskap",
      "membershipQuestions" : "Spørsmål om medlemskap",
      "deleteQuestion" : "Slett spørsmål",
      "deleteQuestionConfirmation" : "Er du sikker på at du vil slette dette spørsmålet?",
      "labels" : {
        "textBox" : "Tekstboks",
        "singleSelect" : "Enkeltvalg",
        "multipleSelect" : "Flere valg",
        "enableMembershipQuestions" : "Legge til minst ett Spørsmål til Aktivere medlemskap spørsmål"
      },
      "validations" : {
        "questionRequired" : "Skriv inn spørsmål",
        "answerOptionsRequired" : "Minst to alternativer er påkrevd, og de må være unike",
        "somethingWentWrong" : "Noe gikk galt. Prøv igjen senere.",
        "updatedQuestions" : "Oppdaterte spørsmål om gruppemedlemskap",
        "levelNameRequired" : "Angi nivånavn",
        "updatedLevelName" : "Oppdatert nivånavn"
      },
      "placeholders" : {
        "enterLevelName" : "Nivånavn",
        "selectOne" : "Velg en",
        "keepItShort" : "Hold det kort...",
        "exampleOffer" : "f.eks 10 % deaktivert ved første kjøp"
      },
      "privacyNotice" : "Jeg forstår at svarene mine vil være Arkivere og synlige for Gruppe-administratorer."
    },
    "gamificationAndRewards" : {
      "title" : "Tilpass nivåer og belønninger",
      "description" : "Tilpass nivånavn og inkluder belønninger for bedre engasjement av medlemmene",
      "gamification" : "Gamifisering",
      "rewards" : "Belønninger",
      "addRewards" : "Legg til belønning"
    },
    "invitations" : {
      "invitationSentSuccessfully" : "Invitasjonen ble sendt",
      "invitationSentSuccessfullyDescription" : "Invitasjonen ble sendt til {email}",
      "shareGroupLink" : "Del gruppelenken din",
      "inviteMember" : "Inviter medlem",
      "inviteMemberDescription" : "Bygg opp fellesskapet ditt ved å invitere et nytt medlem",
      "inviteViaEmail" : "Inviter via e-post",
      "invitedMembersWillBeAutoApproved" : "Inviterte medlemmer blir automatisk godkjent til å bli med i gruppen",
      "sendInvite" : "SEND INVITASJON",
      "permissionDenied" : "Du har ikke Autorisasjon til å invitere Medlemmer. Ta kontakt med administratoren din.",
      "labels" : {
        "giveAdministrativePrivileges" : "Gi administrative privilegier",
        "giveAdministrativePrivilegesDescription" : "Tillat at dette medlemmet kan utføre alle administrative handlinger",
        "name" : "Navn",
        "email" : "E-post"
      },
      "placeholders" : {
        "enterName" : "Skriv inn navn",
        "enterEmail" : "Skriv inn e-postadresse"
      }
    },
    "groupDetails" : {
      "updateGroupDetails" : "Oppdater gruppedetaljer",
      "updateGroupDetailsDescription" : "Oppdater gruppedetaljene dine her",
      "slugNotAvailable" : "Gruppe-slug ikke tilgjengelig",
      "description" : "Utdyp hva slags diskusjoner som vil finne sted i gruppen",
      "publicDescription" : "Alle kan se gruppeinnleggene og andre medlemmer av gruppen",
      "privateDescription" : "Bare medlemmer kan se gruppeinnleggene og andre medlemmer av gruppen",
      "accessibleFromSwitcher" : "Tilgjengelig fra bryteren",
      "accessibleFromSwitcherDescription" : "Gruppen din vil være synlig for ikke-gruppemedlemmer i bryteren",
      "allowMembersToInvite" : "Aktivere Medlemmer for å invitere nye Medlemmer",
      "allowMembersToInviteDescription" : "Skjul invitasjonen Knapp for Medlemmer Når slått Deaktivert. Medlemmer kan bare invitere Annen/annet Hvis dette er Aktivert.",
      "slug" : "Gruppe-slug",
      "discovery" : {
        "title" : "Oppdagelse",
        "description" : "Bli funnet av millioner av aktive brukere. Gruppen vil være synlig på siden Oppdag når du har flere enn ti medlemmer.",
        "discoverChannels" : "Oppdage kanaler",
        "joinGroupToExploreAllChannels" : "bli med gruppen for å utforske hver eneste kanalene"
      },
      "placeholders" : {
        "description" : "Skriv inn en kort beskrivelse"
      },
      "validations" : {
        "nameRequired" : "Skriv inn et gyldig gruppenavn.",
        "slugRequired" : "Skriv inn en gyldig gruppe-slug.",
        "specialCharacterNotSupported" : "Spesialtegn støttes ikke",
        "descriptionRequired" : "Gruppebeskrivelse er påkrevd.",
        "emailRequired" : "Skriv inn en gyldig e-post.",
        "fullNameRequired" : "Vennligst skriv inn et gyldig navn."
      },
      "labels" : {
        "groupName" : "Gruppe"
      }
    },
    "subscriptions" : {
      "manageSubscriptions" : "Administrer tilknytningen din",
      "viewAndManageGroupSubscriptions" : "Se og Administrere Gruppe Abonnement",
      "paymentIntegrationMissingMessage" : "Vennligst integrer betalinger in Sted til Aktivere Betalt Gruppe",
      "price" : "Pris",
      "currency" : "Valuta",
      "priceDisplay" : "{symbol}{price}{suffix}",
      "priceInterval" : "/{interval}",
      "oneTime" : " Én Dato",
      "priceDeletedAlert" : "Betalingsprodukt er Fra Synkronisering, klikk her for å synkronisere på nytt",
      "intervals" : {
        "month" : "Måned",
        "year" : "År",
        "week" : "Uke",
        "day" : "Dag"
      },
      "addNewPrice" : "Legge til til ny Pris",
      "editPrice" : "Redigere Pris",
      "addPrice" : "Legge til Pris",
      "subscriptionType" : {
        "recurring" : "Gjentakende",
        "oneTime" : "Én Dato"
      },
      "billingPeriod" : {
        "monthly" : "Månedlig",
        "annually" : "Årlig",
        "weekly" : "Ukentlig",
        "daily" : "Daglig"
      }
    },
    "menuOptions" : {
      "details" : "Detaljer",
      "subscriptions" : "Abonnement",
      "branding" : "Merkevarebygging",
      "themes" : "Tema",
      "membershipQuestions" : "Spørsmål om Medlemskap",
      "gamificationAndRewards" : "Gamifisering og belønninger",
      "links" : "Lenker",
      "reportedContent" : "Rapportert Innhold",
      "discovery" : "Oppdagelse",
      "import" : "Import"
    },
    "groupSettings" : {
      "groupSettings" : "Gruppe Innstillinger",
      "changeGroupType" : "Endre Gruppe Type",
      "changeGroupTypeDescriptionPrivateToPublic" : "Dynamisk to a Offentlig Gruppe betyr at hver eneste I påvente av Forespørsler blir Godkjent automatisk, og Innhold vil bli offentlig synlig. Fortsette?",
      "changeGroupTypeDescriptionPublicToPrivate" : "Dynamisk to a Privat Gruppe betyr at nye medlemmer trenger Godkjenning og Innhold forblir Skjult til de er Godkjent. Fortsette?",
      "changeGroupTypeConfirmation" : "Er du sikker på at du vil Endre Gruppe Type?",
      "changeGroupTheme" : "Endre Gruppe Tema",
      "changeGroupThemeDescription" : "Dette vil Endre the Tema for hver eneste the Gruppe Medlemmer. Er du sikker på at du vil Endre Gruppe Tema?",
      "updatedGroupDetails" : "Oppdatert gruppedetaljer",
      "unableToSaveDetails" : "Oops! Kan ikke arkivere detaljer.",
      "groupNameIsRequired" : "Gruppenavn er Obligatorisk",
      "groupDescriptionIsRequired" : "Gruppebeskrivelse er obligatorisk",
      "groupSlugIsRequired" : "Gruppe Slug er Obligatorisk",
      "groupSlugAlreadyExists" : "Gruppe Slug finnes allerede. Vennligst bruk en annen Slug , siden denne allerede er tatt",
      "pleaseTryAgainLater" : "Vennligst prøv igjen senere",
      "unsavedChangesMessage" : "Du har Gruppe Slug Dynamisk som ikke er lagret, er du sikker på at du vil angre dem?"
    },
    "import" : {
      "header" : "Import Skool Gruppe Medlemmer og deres Innhold",
      "credentialDescription" : "Skriv inn Skool-sertifikatet ditt for å Import Gruppe Medlemmer og deres Innhold",
      "csvUploadDescription" : "Velge .csv Fil for å Import kontakter Fra Skool",
      "loginFailed" : "Du har skrevet inn et ugyldig e-post Eller password. Vennligst prøv igjen.",
      "proceedWithImport" : "Fortsette med Import?",
      "iAgree" : "Jeg er enig",
      "importTerms" : "Ved å klikke på «Jeg godtar», bekrefter og anerkjenner Du at Du har engasjert oss som en uavhengig Avtale til å utføre Tjenester på dine vegne («Tjenester»). The Tjenester Inkludere the Overføre av certain data, Detaljer, Innhold, intellectual Egenskaper Eller any Annen/annet Innhold (\"Info\") Fra a Utstedt Platform Konto to a Mottatt Platform Konto. Du representerer og garanterer at (i) du er de rettmessige Eier av Info in Utstedt Platform Konto, (ii) Du har Tillatelser til å gi oss Tilgang til Utstedt Platform Konto for Hensikt av som utfører Tjenester, og (iii) Overføre av Info vil ikke krenke noen tredjeparts intellektuelle Egenskaper Tillatelser Eller bryte noen tredjepartskontrakter. Du samtykker i å holde oss skadesløs, forsvare og holde oss skadesløse for eventuelle tredjepartskrav som oppstår som et resultat av bruddet ditt av representantene og garantiene ovenfor.",
      "pleaseDownloadCSV" : "Last ned .CSV-fil",
      "step01" : "Skritt 01–",
      "step02" : "Skritt 02–",
      "uploadCSV" : "Last Laste opp .CSV",
      "step01Description" : "Fylle in Eller oppdater eventuelle manglende detaljer for gruppemedlemmer som for eksempel Gmail, fornavn osv. Sørg for at CSV er lastet opp in",
      "thisTemplate" : "denne Mal",
      "importCSV" : "Import .CSV",
      "reSyncData" : "Re-Synkronisering av dataene dine Før Laste ned.",
      "refreshUserList" : "Oppdater Bruker Liste",
      "reSyncDataDescription" : "Hvis nye brukere er lagt til in mellomtiden, foreslår vi at Du oppdaterer listen og laster ned CSV.",
      "pleaseDontChangeProfileSlug" : "Vennligst ikke Endre Profil Slug.",
      "selectFile" : "Velge Fil",
      "changeFile" : "Fil Endre",
      "importMembersFailedText" : "Dette kan være fordi de mangler e-postadresse. Vennligst Hake Import Fil og Prøv igjen med gyldig e-post-adresse for disse medlemmene.",
      "upload" : "Laste opp",
      "tryAgain" : "Prøv igjen",
      "syncAllPosts" : "Synkronisering hver eneste din Slett og Kommenter",
      "membersCouldNotBeAdded" : "Medlemmer kunne ikke legges til i gruppen.",
      "importMembersSuccess" : "Vi har sendt en e-post til hver eneste Individ Gruppe Medlemmer, som bekrefter deres medlemskap in gruppen og gir dem Tilgang Detaljer. Dette bidrar til å sikre at hver eneste medlemmer er informert og kan Tilgang med Gruppen effektivt.",
      "importMembersAdded" : "Medlemmer har blitt lagt til i gruppen",
      "postsNotSynced" : "Gjenværende innlegg kunne ikke synkroniseres til gruppen. Dette kan være fordi Dele Forfattere ikke ble importert på hell.",
      "migrationFailed" : "Migreringen mislyktes. Vennligst prøv igjen.",
      "migrationCompleted" : "Migrasjon Ferdig!",
      "migrationInProgress" : "Migrering in .",
      "uploadingInProgress" : "Siste opp in .",
      "listMembers" : "Liste av Medlemmer blir",
      "downloaded" : "Last ned",
      "uploaded" : "lastet opp",
      "listPostsDownloaded" : "Liste av innlegg er lastet ned.",
      "listPostsDownloading" : "Liste av innlegg blir lastet ned.",
      "posts" : "innlegg",
      "members" : "Medlemmer",
      "imported" : "importert",
      "step1" : "Skritt 1",
      "step2" : "Skritt 2",
      "step1Description" : "Skape en medlemsprofil in Skool Gruppe.",
      "step1Description2" : "(inkludert navn, e-post Id og passord)",
      "step2Description" : "Skriv inn Skool Medlemmer Sertifikat",
      "emailPlaceholder" : "Skriv inn Skools e-post- Id",
      "emailTooltip" : "Skriv inn e-posten Medlemmer med din skolekonto",
      "passwordPlaceholder" : "Skriv inn Skool-passordet ditt",
      "confirm" : "Bekreft",
      "validation" : {
        "skoolUrl" : "Skriv inn en gyldig Skool-URL",
        "email" : "E-post er obligatorisk",
        "password" : "Passordet er obligatorisk"
      }
    }
  },
  "invitations" : {
    "intent" : "Help dette fellesskapet å vokse.",
    "cancelInvitation" : "Kanseller invitasjonen",
    "inviteMembers" : "Inviter medlemmer til å samarbeide om dette fellesskapet.",
    "inviteLink" : "Invitasjonslenke",
    "buildYourCommunity" : "Bygg ditt fellesskap.",
    "inviteMembersToCollaborate" : "Du har opprettet et nytt fellesskap. Inviter medlemmer til å samarbeide om dette fellesskapet.",
    "invite" : "Inviter"
  },
  "createPost" : {
    "title" : "Opprett nytt blogginnlegg",
    "placeholder" : "Hva tenker du på",
    "slug" : "Blogginnlegg – URL-slug",
    "titleHelp" : "Tittelen, beskrivelsen og bildet vil bli brukt for SEO meta tag",
    "nameLabel" : "Tittel på blogginnlegg",
    "nameValidation" : "Tittel er påkrevd",
    "descriptionLabel" : "Beskrivelse av innlegget",
    "descriptionHelp" : "Gi en kort beskrivelse slik at seerne kan få et glimt av innlegget. Fungerer best mellom 100–250 tegn",
    "descriptionValidation" : "Beskrivelse er påkrevd",
    "createLabel" : "Opprett innlegg",
    "image" : "Bilde av blogginnlegg",
    "imageDescription" : "Anbefalt størrelse er 600px * 400px",
    "notificationTitle" : "Blogginnlegg opprettet",
    "notificationErrorTitle" : "Kunne ikke opprette blogginnlegg",
    "postingIn" : "Legger in",
    "editingIn" : "Redigering in"
  },
  "post" : {
    "deletePost" : "Slett innlegg",
    "reportPost" : "Rapporter innlegg",
    "editPost" : "Rediger innlegg",
    "createPost" : "Opprett innlegg",
    "publish" : "Innlegg",
    "publishPost" : "Publiser innlegg",
    "addChannel" : "Legg til kanal",
    "selectChannel" : "Velg kanal",
    "addLink" : "Legg til lenke",
    "removeLink" : "Fjern lenke",
    "update" : "Oppdater",
    "unsavedChanges" : "Du har endringer som ikke er lagret",
    "unsavedChangesMessage" : "Du vil miste endringene du ikke har lagret. Vil du fortsatt gå videre?",
    "unpinFromChannel" : "Løsne",
    "unpinFromHome" : "Løsne",
    "deletePostConfirmation" : "Er du sikker på at du vil slette dette innlegget?",
    "reportPostConfirmation" : "Er du sikker på at du vil rapportere dette innlegget?",
    "postNotFound" : "Finner ikke innlegget",
    "postNotFoundMessage" : "Innlegget du prøver å se er enten slettet eller det eksisterer ikke.",
    "loadMoreComments" : "Last inn flere kommentarer",
    "channelNotFound" : "Kanal ikke funnet",
    "isCurrentlyLive" : "er for øyeblikket live",
    "isStartingNow" : "begynner nå",
    "isHappeningInMinutes" : "skjer om {minutes} minutter",
    "isHappeningInHours" : "skjer in {hours} tid | skjer in {hours} tid",
    "publicChannel" : "Offentlig kanal",
    "privateChannel" : "Privat kanal",
    "featured" : "Utvalgte",
    "featuredAbout" : "Om utvalgte",
    "noPostsFound" : "Ingen innlegg funnet",
    "pinInfo" : "Du kan feste elementer som skal vises øverst i gruppen, inkludert innlegg, regler og emneknagger.",
    "pinInfoEveryone" : "Alle i gruppen vil se disse elementene.",
    "pinInfoRemainVisible" : "Festede elementer forblir synlige til du løsner dem.",
    "pinInfoNewestItem" : "Når du fester elementer, vises det nyeste elementet først på listen.",
    "onlyVisibleToAdmins" : "Kun synlig for administratorer",
    "featuredAboutDescription" : "Administratorene dine har festet disse elementene slik at gruppen kan se dem.",
    "channelNotFoundMessage" : "Du er ikke lenger medlem av kanalen du prøver å få tilgang til, eller kanalen er slettet.",
    "notifications" : {
      "unpinned" : "Løsnet.",
      "pinned" : "Festet.",
      "reported" : "Innlegget har blitt rapportert.",
      "error" : "Noe gikk galt."
    },
    "movePostToChannel" : "Flytte til kanal",
    "pin" : "Pin",
    "pinToHome" : "Fest til startsiden",
    "pinToChannel" : "Fest til kanalen",
    "whatIsYourTitle" : "Hva er din Tittel?",
    "postMovedToChannel" : "Slett ble flyttet til {channelName} kanal",
    "onlyAdminsCanPost" : "Only community admins can post in this channel."
  },
  "reaction" : {
    "noLikes" : "Ingen likes",
    "andOthers" : "og {count} andre"
  },
  "UIConfirmation" : {
    "privateGroup" : "Denne gruppen er privat",
    "privateGroupMessage" : "Du må være medlem av denne gruppen for å få tilgang til gruppespesifikk informasjon. Vennligst be om tilgang ved å klikke på Bli med i gruppe-knappen."
  },
  "notifications" : {
    "noNotificationsYet" : "Ingen varsler ennå",
    "whenYouGetNotifications" : "Når du får varsler, vil de vises her",
    "markAllAsRead" : "Merk alle som lest",
    "notifications" : "Notifikasjoner",
    "all" : "Alle",
    "unread" : "Ulest",
    "checkNotifications" : "Logg inn for å sjekke varsler",
    "noNotifications" : "Ingen varsler."
  },
  "joinGroupModal" : {
    "wahoo" : "Jippi! 🎉 Forespørselen er sendt",
    "reviewRequestSoon" : "Våre gruppeadministratorer vil snart vurdere forespørselen din. Vær tålmodig. Vi varsler deg når medlemskapet ditt er godkjent.",
    "nonMemberMessage" : "Du må være en del av denne gruppen for å like og kommentere på innlegg",
    "subscribeFor" : "Abonner på",
    "joinGroup" : "BLI MED I GRUPPEN",
    "membershipPending" : "Medlemskap PENDING",
    "viewMembershipAnswers" : "Se svar på Medlemskap",
    "requested" : "Forespurt",
    "dayFreeTrial" : "dags gratis prøveperiode",
    "notPartOfGroup" : "Du er ikke en del av denne gruppen ennå, ditt Medlemskap Forespørsler er in Vurdering. Når en Admin Godkjent din Forespørsler, vil vi varsle Du",
    "pleaseAnswerMembershipQuestions" : "Vennligst svar på medlemskapsspørsmålene for å bli med denne gruppen",
    "answerQuestions" : "Svar på medlemskapsspørsmål"
  },
  "userProfilePopover" : {
    "active" : "Aktiv",
    "longAgo" : "lenge siden",
    "chatDisabled" : "Denne brukeren har deaktivert chatten sin",
    "pointsToLevelUp" : "poeng for å gå opp i nivå",
    "profile" : "Profil",
    "deletedUser" : "Slettet bruker",
    "joined" : "Ble med",
    "contributions" : "Bidrag"
  },
  "courses" : {
    "addCourse" : "Legg til kurs",
    "updateCourse" : "Oppdater kurs",
    "access" : "Alle medlemmer har tilgang",
    "unableToAddCourse" : "Oops! Kan ikke inkludere kurs",
    "pleaseTryAgainLater" : "Prøv igjen senere",
    "paymentIntegrationMissing" : "Oops! Betalingsintegrering mangler",
    "paymentIntegrationMissingMessage" : "Vennligst integrer betalinger på stedet for å aktivere betalte kurs",
    "course" : "Kurs",
    "courseInThisGroup" : "et kurs i denne gruppen",
    "courseLinkCopied" : "Kurslenke kopiert.",
    "buyNow" : "KJØP NÅ",
    "locked" : "LÅST",
    "buyCourse" : "KJØP KURS",
    "open" : "ÅPEN",
    "moveCard" : "Flytt kort",
    "courseViewMessage" : "Du må være en del av denne gruppen for å se kursene.",
    "deleteCourse" : "Slett kurs",
    "deleteCourseConfirmation" : "Er du sikker på at du vil slette dette kurset?",
    "courseAccessNotGranted" : "Kurstilgang er ikke gitt",
    "courseAccessNotGrantedMessage" : "Vi jobber for tiden med å gi deg tilgang til kurset. Oppdater siden og prøv igjen om et øyeblikk.",
    "autoRenewsAfter" : "Fornyes automatisk etter",
    "oneTimePayment" : "Engangsbetaling",
    "emptyCoursesMessage" : "Ser ut som en spøkelsesby. Ingenting å se her",
    "updatedSuccessfully" : "Kursoppdatert vellykket",
    "addedSuccessfully" : "Kurset ble lagt til",
    "labels" : {
      "selectCourse" : "Velg kurs",
      "courseVisibility" : "Synlighet",
      "courseAccess" : "Kurstilgang",
      "coursePrice" : "Kurspris",
      "subscriptionType" : "Abonnementstype",
      "billingPeriod" : "Faktureringsperiode",
      "testMode" : "Testmodus",
      "turnOnTestPayments" : "Slå på testbetalinger med et testkort",
      "currency" : "Valuta",
      "trialDays" : "Prøveperiode",
      "recurring" : "Gjentakende",
      "free" : "Gratis",
      "oneTime" : "Én Dato",
      "refresh" : "Oppdater",
      "accessStartsAtDay" : "Tilgangen starter Tilgang . Dag",
      "maximumYouCanEnterIs365" : "Maks Du can enter er 365",
      "allMembers" : "hver eneste Medlemmer",
      "levelUnlock" : "Jevn Lås opp",
      "buyNow" : "Kjøp nå",
      "timeUnlock" : "Opplåsing av data",
      "gamificationLevel" : "Gamifisering Jevn",
      "privateChannel" : "Privat kanal",
      "marketingChannel" : "Markedsføring"
    },
    "placeholders" : {
      "enterPrice" : "Angi pris",
      "enterTrialDays" : "Angi prøvedager",
      "selectCurrency" : "Velg en",
      "selectBillingPeriod" : "Velg en"
    },
    "validations" : {
      "validPrice" : "Vennligst skriv inn en gyldig pris",
      "required" : "Velg et kurs",
      "validMembershipPrice" : "Skriv inn gyldig medlemskapspris",
      "validTrialDays" : "Vennligst oppgi gyldige prøvedager",
      "requiredSubscriptionType" : "Vennligst velg abonnementstype",
      "courseVisibility" : "Vennligst Velge kurs Synlighet",
      "requiredGamificationLevel" : "Vennligst Velge Gamifisering Jevn",
      "requiredPrivateChannel" : "Vennligst velg privat kanal",
      "validAccessStartDay" : "Vennligst skriv inn gyldig Tilgang start Dag"
    },
    "descriptions" : {
      "buyNowDescription" : "Dette kurset er offentlig ved kjøp",
      "timeUnlockDescription" : "Medlemmer Låse opp Etter X dager",
      "levelUnlockDescription" : "Medlemmer bare på en viss Jevn vil kunne låse opp",
      "allMembersDescription" : "hver eneste medlemmer har Tilgang til dette kurset",
      "privateChannelDescription" : "Medlemmer av en privat kanal"
    },
    "helperText" : {
      "levelBased" : "Nivåbasert",
      "timeLimited" : "tidsbegrenset",
      "free" : "Gratis",
      "levelAvailableAt" : "Tilgjengelig på Jevn 0{value}",
      "timeLimitedAfterJoining" : "Offentlig {value} {day} Etter blir med i gruppen",
      "day" : "Dag",
      "days" : "dager",
      "purchaseToUnlockAccess" : "Kjøp dette kurset for å låse opp Tilgang",
      "locked" : "Dette kurset er låst",
      "unlockAtLevel" : "Dette kurset vil låses opp på Jevn {level}",
      "unlockAfterDays" : "Dette kurset vil låse opp Etter {days} {dayText}",
      "privateChannelBased" : "Privat kanalbasert"
    }
  },
  "leaderboard" : {
    "level" : "Nivå",
    "lastUpdated" : "Sist oppdatert",
    "members" : "Medlemmer",
    "percentOfMembers" : "{percentage}% av medlemmene",
    "rewards" : "Belønninger",
    "allTime" : "Hele tiden",
    "pointsToLevelUp" : "poeng for å gå opp i nivå",
    "points" : "Poeng",
    "leaderboard7d" : "Ledertavle (7 dager)",
    "leaderboard30d" : "Ledertavle (30 dager)",
    "leaderboardAlltime" : "Ledertavle (gjennom tidene)",
    "yourRank" : "Din rangering",
    "noActivityToShow" : "Ingen aktivitet å vise",
    "rewardsWillBeDisplayedHere" : "Belønninger vil bli vist her",
    "seeAllLeaderboards" : "Se alle ledertavler",
    "addRewards" : "Legg til belønninger",
    "howPointsWork" : "Du tjener poeng når andre medlemmer liker innleggene dine eller gir deg tilbakemelding. 1 like = 1 poeng. Dette oppfordrer brukere til å generere kvalitetsinnhold og samhandle med andre medlemmer i fellesskapet deres.",
    "levels" : "Nivåer",
    "levelsDescription" : "Etter hvert som du får poeng, går du opp i nivåene. Ditt nivå vises nederst til høyre for avataren din. Antall poeng som kreves for å komme til neste nivå vises via fremdriftslinjen på ledertavleskjermen.",
    "pointsAndLevels" : "Poeng & Lag"
  },
  "events" : {
    "createEvent" : "Opprett hendelse",
    "dragAndDrop" : "Dra og slipp en SVG-, PNG- eller JPG-fil (maks 800x400 piksler)",
    "editEvent" : "Rediger hendelse",
    "addEvent" : "Legg til hendelse",
    "paymentDetails" : "Betalingsdetaljer",
    "event" : "Hendelse",
    "goBack" : "Gå tilbake",
    "cancelEdit" : "Kanseller redigering",
    "cancelEvent" : "Kanseller hendelsen",
    "next" : "Neste",
    "saveEvent" : "Lagre hendelse",
    "editRecurringEvent" : "Rediger gjentakende hendelse",
    "thisEvent" : "Denne hendelsen",
    "thisAndFollowingEvents" : "Denne og de etterfølgende hendelsene",
    "ok" : "OK",
    "deleteRecurringEvent" : "Slett gjentakende hendelser",
    "allEvents" : "Alle hendelser",
    "adminsFreeForPaidEvents" : " * Administratorer kan registrere seg for Betalt Hendelser gratis",
    "deleteEvent" : "Slett hendelse",
    "onceEventDeleted" : "Når en hendelse er slettet, vil den ikke vises i kalenderen din.",
    "toRegister" : "for å registrere",
    "calendar" : "Kalender",
    "addToCalendar" : "Legg til i kalenderen",
    "declineRegistration" : "Avslå",
    "paymentFailedMessage" : "Betalingen din mislyktes på grunn av uforutsette omstendigheter. Prøv igjen senere.",
    "upcoming" : "Kommende",
    "noMoreEvents" : "Ingen flere hendelser å vise",
    "joinGroupToRegister" : "Du må være en del av denne gruppen for å registrere deg for denne hendelsen",
    "past" : "Tidligere",
    "youHaveRegisteredForOneEvent" : "Du har registrert deg for en hendelse. Vi sender deg en påminnelse en dag før hver hendelse.",
    "upcomingEvents" : "Kommende hendelser",
    "noUpcomingEvents" : "Ingen kommende hendelser",
    "pastEvents" : "Tidligere hendelser",
    "noPastEvents" : "Ingen tidligere hendelser",
    "noMatchingEventFound" : "Fant ingen matchende hendelse",
    "week" : "Uke",
    "month" : "Måned",
    "today" : "I dag",
    "registrationConfirmed" : "Registrering Bekreftet for {event}.",
    "validations" : {
      "titleValidation" : "Tittel er påkrevd",
      "colorValidation" : "Farge er påkrevd",
      "startTimeValidation" : "Starttid er påkrevd",
      "endTimeValidation" : "Slutt-tid er påkrevd",
      "endTimeAfterStartTime" : "Sluttidspunktet må være etter starttidspunktet",
      "startTimeMustBeInFuture" : "Starttidspunktet må være i fremtiden",
      "locationValidation" : "Sted er obligatorisk",
      "locationValidationMobile" : "Sted er påkrevd",
      "locationUrlValidation" : "Gyldig steds-URL er nødvendig",
      "descriptionValidation" : "Beskrivelse er påkrevd",
      "descriptionValidationMaxLength" : "Beskrivelsen kan ikke overstige 300 tegn",
      "recaptchaError" : "Verifisering mislyktes. Prøv igjen",
      "repeatIntervalValidation" : "Hyppighet er påkrevd",
      "repeatIntervalValidator" : "Gjentakelsesintervall må være enten dag, uke, måned eller år",
      "repeatIntervalRequired" : "Gjentakelsesintervall er påkrevd",
      "repeatOccurrenceValidator" : "Gjentakelseshyppighet må være større enn 0",
      "repeatOccurrenceRequired" : "Gjentakelseshyppighet er påkrevd",
      "invalidDateFormat" : "Ugyldig dato format",
      "endDateMustBeAfterStartDate" : "Sluttdatoen må være etter arrangementets startdato",
      "recurringEndDateValidation" : "Gjentakende sluttdato er påkrevd",
      "repeatsOnValidation" : "Velg minst én dag",
      "invalidDaySelection" : "Ugyldig valg av dag",
      "endOptionRequired" : "Slutt-alternativ er påkrevd",
      "levelValidation" : "Velg et nivå",
      "courseValidation" : "Velg et kurs",
      "channelValidation" : "Velg en kanal",
      "eventPriceValidation" : "Pris er obligatorisk og må være større enn {min}"
    },
    "placeholders" : {
      "selectStartTime" : "Velg starttid",
      "selectEndTime" : "Velg sluttid",
      "selectLocation" : "Velg sted",
      "locationUrl" : "Lenke/adresse",
      "description" : "Beskrivelse",
      "selectRecurringEndDate" : "Velg gjentakende sluttdato",
      "selectDate" : "Velg dato",
      "event" : "Hendelse",
      "selectColor" : "Velg en farge",
      "selectAttendees" : "Velg deltakere",
      "selectPrivateChannel" : "Velg privat kanal",
      "selectCourse" : "Velg kurs",
      "selectLevels" : "Velge nivåer",
      "selectCalendar" : "Velg kalender"
    },
    "labels" : {
      "startTime" : "Starttid",
      "endTime" : "Sluttid",
      "others" : "Andre",
      "oneTimePriceForEventRegistration" : "engangspris for påmelding til arrangementet.",
      "totalAmount" : "Totalbeløp",
      "cardAuthorizationText" : "Ved å oppgi kortinformasjonen din, tillater du {locationName} å belaste kortet for fremtidige betalinger i samsvar med vilkårene deres.",
      "secureAndSafePayments" : "100 % sikre og trygge betalinger",
      "day" : "Dag",
      "week" : "Uke",
      "month" : "Måned",
      "year" : "År",
      "recurringEvent" : "Vil arrangementet være en gjentakende hendelse?",
      "repeatsEvery" : "Gjentas hver/hvert",
      "repeatsOn" : "Gjentas",
      "end" : "Slutt",
      "ends" : "Lukke",
      "neverEnds" : "Tar aldri slutt",
      "orange" : "Oransje",
      "red" : "Rød",
      "blue" : "Blå",
      "green" : "Grønn",
      "violet" : "Fiolett",
      "purple" : "Lilla",
      "yellow" : "Gul",
      "title" : "Tittel",
      "color" : "Farge",
      "allMembers" : "Alle medlemmer",
      "membersAtALevel" : "Medlemmer på et nivå",
      "membersOfACourse" : "Medlemmer av et kurs",
      "membersOfAPrivateChannel" : "Medlemmer av en privat kanal",
      "whoCanAttendTheEvent" : "Hvem kan delta på arrangementet?",
      "channel" : "Kanal",
      "course" : "Kurs",
      "level" : "Nivå",
      "remindAttendeesByEmail" : "Minn deltakere Via E-post 1 Dag Før",
      "hideLocationFromNonAttendees" : "Skjul sted fra ikke-deltakere.",
      "addChargesToTheEvent" : "Legge til fakturering til hendelsen",
      "noPaymentRequired" : "Ingen betaling Obligatorisk",
      "location" : "Sted",
      "link" : "Lenke",
      "description" : "Beskrivelse",
      "timezone" : "Tidssone",
      "eventType" : "Hendelsestype",
      "eventTypeChangeWarning" : "Dynamisk to the Hendelsestype Eller pricing vil Iverksette til hver eneste hendelse in serien.",
      "never" : "Aldri",
      "on" : "På",
      "after" : "Etter",
      "occurrences" : "hendelser",
      "selectEventEnd" : "Velge Når the Hendelse will Slutt.",
      "turnOnTestPayments" : "Vend På Test Via Test",
      "pay" : "Betale",
      "hideAttendees" : "Skjul deltakere Fra Gruppe Medlemmer",
      "guests" : "{count} gjester",
      "guestList" : "Gjest Liste",
      "noAttendees" : "Ingen deltakere ennå",
      "viewAttendees" : "Se",
      "exportAttendees" : "Eksport deltakere"
    },
    "notifications" : {
      "eventCreated" : "Hendelse vellykket Opprettet!",
      "eventUpdated" : "Hendelse vellykket Oppdatert!",
      "eventCreationFailed" : "Oppretting av Hendelse mislyktes.",
      "eventUpdateFailed" : "Oppdatering av Hendelse mislyktes.",
      "eventDeleted" : "Hendelsen er slettet.",
      "eventDeletionFailed" : "Sletting av hendelse mislyktes.",
      "paymentFailed" : "Betaling mislyktes.",
      "registrationSuccessful" : "Registrering vellykket.",
      "registrationFailed" : "Registrering mislyktes.",
      "addToCalendarFailed" : "Kunne ikke legge til hendelsen i kalenderen.",
      "locationDetailsCopied" : "Stedsdetaljer kopiert til utklippstavlen.",
      "registrationDeclined" : "Registreringen ble avvist.",
      "registrationDeclinedFailed" : "Avslag på registrering mislyktes.",
      "fetchAttendeesFailed" : "Kunne ikke laste inn deltakere",
      "emailCopied" : "E-post Kopier til utklippstavlen"
    }
  },
  "login" : {
    "invite" : "inviterte deg til å bli med"
  },
  "contentReports" : {
    "contentDeleted" : "Innhold har blitt slettet.",
    "noActionTaken" : "Ingen handling foretatt på det rapporterte innholdet.",
    "reportedContentNotFound" : "Finner ikke rapportert innhold. Det kan hende at det allerede er gjort noe med det.",
    "reported" : "Rapportert",
    "viewAllReportedContentHere" : "Du kan se alt det rapporterte innholdet her",
    "takeActionOnReportedContent" : "Reager på det rapporterte innholdet",
    "andOthers" : "og {count} andre",
    "reportedThisPost" : "rapporterte dette innlegget",
    "keep" : "BEHOLD",
    "remove" : "FJERN",
    "deleteContent" : "Slett innhold",
    "deleteConfirmation" : "Er du sikker på at du vil slette dette innholdet?",
    "noMemberReportedContent" : "Ingen innholdsrapporter fra medlemmer",
    "whenMembersReportPostsOrComments" : "Når medlemmer rapporterer innlegg eller tilbakemeldinger, vil det vises her slik at du kan vurdere det. Du kan beholde eller slette det, samt deaktivere, fjerne eller blokkere medlemmene som postet dem."
  },
  "contentUnavailable" : {
    "thisContentIsntAvailable" : "Dette innholdet er ikke tilgjengelig for øyeblikket",
    "whenThisHappens" : "Når dette skjer, er det vanligvis fordi eieren bare delte det med en liten gruppe mennesker eller endret hvem som kan se det, eller det ble slettet"
  },
  "noCommunities" : {
    "noCommunitiesFound" : "Ingen fellesskap funnet",
    "startCreatingYourOwnCommunities" : "Begynn å lage dine egne fellesskap og engasjere publikummet ditt."
  },
  "notFound" : {
    "ohNo" : "å nei...",
    "weHaveHadAnError" : "Det har oppstått en feil",
    "error404" : "Feilmelding 404",
    "sorryPleaseCheckBack" : "Beklager... Kom tilbake snart."
  },
  "time" : {
    "justNow" : "Akkurat nå",
    "timeAgo" : "for {value}for{unit} siden",
    "timeAgoFull" : "for {value} for {unit} siden",
    "units" : {
      "year" : "å",
      "years" : "år",
      "month" : "md",
      "months" : "måneder",
      "week" : "w",
      "weeks" : "uker",
      "day" : "d",
      "days" : "dager",
      "hour" : "h",
      "hours" : "tid",
      "minute" : "m",
      "minutes" : "minutter",
      "second" : "s",
      "seconds" : "Sekunder",
      "monthly" : "Månedlig",
      "weekly" : "Ukentlig",
      "annually" : "Årlig"
    }
  },
  "emojiPicker" : {
    "notfound" : "Ingen emoji funnet",
    "recent" : "Mye brukt",
    "smileys" : "Smileys og uttrykksikon",
    "people" : "Mennesker og Hoveddel",
    "nature" : "Dyr og natur",
    "foods" : "Mat og drikke",
    "activity" : "Aktivitet",
    "places" : "Travel & Seter",
    "objects" : "Objekter",
    "symbols" : "Symboler",
    "flags" : "Flagg",
    "custom" : "Tilpasset"
  },
  "topNavBarHeaderText" : {
    "discussion" : "Diskusjon",
    "learning" : "læring",
    "people" : "Mennesker"
  }
}
